import * as calculator from "./calculation";
import * as estimator from "./estimation";

export const DataGrids = {
  DataGridView5: [
    "Component",
    "Diameter",
    "Material",
    "Can Length",
    "Long Seam Angle",
    "Provided Thickness",
    "Weight (Kg)",
  ],
  DataGridView6: [
    "Allowable_Stress",
    "Required_Thickness",
    "UCS_Curve",
    "MDMT",
    "MAWP",
    "Hydrotest_Pressure",
  ],
  DataGridView7: [
    "Circ_Weld_Hours",
    "Long_Weld_Hours",
    "Rolling_Hours",
    "Dishing_Hours",
  ],
  DataGridView1: [
    "Mark",
    "Service",
    "Size",
    "Type",
    "Flange Rating",
    "Sch/Thk",
    "Weld Detail",
    "Nozzle Weld (A)",
    "Inside Weld (B)",
    "Pad Weld (C)",
    "Outside Proj",
    "Inside Proj",
    "Pad OD",
    "Pad Thk",
  ],
  DataGridView3: [
    "Nozzle Thk Reqd",
    "Area Reqd",
    "Area Available",
    "Nozzle Weld (A) Reqd",
    "Nozzle Weld (B) Reqd",
    "Nozzle Weld (C) Reqd",
    "Flange Mawp",
    "Nozzle MDMT",
    "Flange MDMT",
    "Pad MDMT",
  ],
  DataGridView2: [
    "Flange Weight",
    "Pipe Weight",
    "Pad Weight",
    "Nozzle Man-Hours",
    "Bolt-up Hours",
    "Long Weld",
    "Circ Weld",
    "NDT Cost",
  ],
  DataGridView10: [
    "Dist From DL",
    "Orientation",
    "Dist From CL (+/-)",
    "Direction",
    "Location",
    "Nozzle Material",
    "Flange Material",
    "Pad Material",
  ],
  DataGridView11: [
    "Nozzle Material",
    "Nozzle Allowable Stress",
    "Flange Material",
    "Material Group",
    "Pad Material",
    "Pad Allowable Stress",
    "Nozzle MDMT Curve",
    "Flange MDMT Curve",
    "Pad MDMT Curve",
  ],
  DataGridView13: [
    "Item",
    "Qty",
    "Material Cost/KG",
    "Man-Hours",
    "Material Cost",
  ],
  DataGridView8: [
    "Code",
    "Component",
    "Description",
    "Bom Adder",
    "Qty",
    "Measure/Wt",
    "Unit",
    "Material Cost/ Unit",
    "Material Cost",
    "FAB Hours",
    "FAB Rate/Hr",
    "FAB Cost",
    "Remarks",
  ],
  DataGridView18: [
    "Diameter",
    "components",
    "Length",
    "Thickness",
    "Material",
    "Requirements",
    "materialCode",
    "materialDescription",
  ],
};

export const materialData = [
  {
    label: "Shell",
    materialFieldName: "ComboBox9",
    stressFieldName: "TextBox68",
    curveFieldName: "TextBox88",
    stressPairfields: [
      "txt_AS_CSC",
      "txt_AS_EHC",
      "txt_SAS_NC1",
      "TextBox68",
      "txt_AS_SC",
    ],
  },
  {
    label: "Head",
    materialFieldName: "ComboBox11",
    stressFieldName: "TextBox73",
    curveFieldName: "TextBox90",
  },
  {
    label: "Nozzle Pipe ",
    materialFieldName: "ComboBox12",
    stressFieldName: "TextBox78",
    curveFieldName: "TextBox95",
    stressPairfields: ["txt_NAS_NC1"],
  },
  {
    label: "Flange/Forging",
    materialFieldName: "ComboBox13",
    stressFieldName: "TextBox79",
    curveFieldName: "TextBox96",
  },
  {
    label: "RF Pad",
    materialFieldName: "ComboBox14",
    stressFieldName: "TextBox81",
    curveFieldName: "TextBox102",
  },
  {
    label: "Stud Bolt/Nut",
    materialFieldName: "ComboBox15",
    stressFieldName: "TextBox82",
    curveFieldName: "TextBox103",
  },
  {
    label: "Gasket",
    materialFieldName: "ComboBox16",
    stressFieldName: "TextBox86",
    curveFieldName: "TextBox104",
  },
];

// convert the data file to a json object in required format
export function parseData(formattedString, DataGrids) {
  const lines = formattedString.trim().split(/\r?\n/);
  console.log("got the lines -", lines.length);

  var convertedData = {};
  let currentKey = null;
  let dataArray = null;

  // loop through each line.
  // if line contains '|' , split and convert to key:value pair
  // if line starts with "DataGridView", initialize the DGV array
  // after the dgv occurence, lines will start with '/t' indicating them to be the dgv array elements--
  //  --push the values for given dgv.
  for (const line of lines) {
    console.log("line processed", line);
    if (
      line.includes("|") &&
      !line.includes("\t") &&
      !line.includes("DataGridView")
    ) {
      const [key, value] = line.split("|");
      convertedData[key] = value;
    } else if (line.startsWith("\t")) {
      let trimmedLine = line.trim();
      const values = trimmedLine.split("|\t");
      let item = {};
      DataGrids[currentKey].forEach((key, index) => {
        item[key] = values[index].trim().replace("\t", "").replace("|", "");
      });
      dataArray.push(item);
    } else {
      let trimmedLine = line.trim();
      if (DataGrids.hasOwnProperty(trimmedLine)) {
        currentKey = trimmedLine;
        dataArray = [];
        convertedData[currentKey] = dataArray;
      }
    }
  }

  return convertedData;
}

// convert data into txt file format seperated by "|" ,"\t" and "\n"
export function formatData(data) {
  let result = "";

  for (const key in data) {
    if (Array.isArray(data[key])) {
      result += `${key}\n`;
      for (const item of data[key]) {
        const values = Object.values(item).join(" |	"); //make sure this line has one tab before | and 2 tab spaces after
        result += `\t${values}\t|\n`;
      }
    } else {
      result += `${key}|${data[key]}\n`;
    }
  }

  return result;
}

export const estimateAll = async (input) => {
  let dataWithEstimation = input;
  let resultShell = {};
  resultShell["Cylindrical"] = calculator.Cylindrical_Shell_Calc(input);
  resultShell["Elliptical"] = calculator.Elliptical_Head_Calc(input);
  dataWithEstimation = Object.assign(
    {},
    input,
    resultShell["Elliptical"],
    resultShell["Cylindrical"]
  );
  console.log("Here?");
  console.log(input);

  //shell est depends on shellCalc - so is done seperately first
  const shellCalc = await calculator
    .Shell_Calc(input, resultShell)
    .then((response) => {
      console.log("DAtagrid6: ", response, input["DataGridView6"]);
      // if (input["DataGridView6"])
      dataWithEstimation["DataGridView6"] = response;
      // else
      //     input.push({ "DataGridView6": response })
      console.log("resp", response);
    })
    .catch((err) => {
      console.log(err);
    });
  console.log("sehll calcd", input.DataGridView6);

  // if(input["DataGridView6"].length<1) // could be done, but the estimatino might be old, so better run it regardless...
  const shellEstimate = calculator
    .shellEstimation(dataWithEstimation)
    .then((response) => {
      // if (input["DataGridView7"])
      dataWithEstimation["DataGridView7"] = response[1];
      dataWithEstimation["DataGridView5"] = response[0];
      // else
      // input.push({ "DataGridView7": response })
      // console.log("resp", response)
    })
    .catch((err) => {
      console.log(err);
    });

  const nozzleEstimate = estimator
    .estimateNozzle(dataWithEstimation)
    .then((response) => {
      console.log("DAtagrid7: ", response, dataWithEstimation["DataGridView2"]);
      // if (dataWithEstimation["DataGridView2"])
      dataWithEstimation["DataGridView2"] = response;
      // else
      //     dataWithEstimation.push({ "DataGridView2": response })
      // console.log("resp", response)
    })
    .catch((err) => {
      console.log(err);
    });

  console.log("nozle");

  const saddleEstimate = estimator
    .estimateSaddle(dataWithEstimation)
    .then((response) => {
      // console.log("DAtagrid6: ",response)
      // if (dataWithEstimation["DataGridView13"].length || typeof (dataWithEstimation["DataGridView13"]) != "undefined")
      dataWithEstimation["DataGridView13"] = response;
      // else
      //     input.push({ "DataGridView13": response })
      console.log("resp", response);
    })
    .catch((err) => {
      console.log(err);
    });

  console.log("sadle");
  await Promise.all([shellEstimate, nozzleEstimate, saddleEstimate]);
  console.log("done estimations");
  return dataWithEstimation;
};

export const AppendToFile =
  "PanelShell_Head|True\nPanelNozzle|True\nPanel16|True\nPanel20|True\nPanelEstimation|True\nButton23|True\nButton11|True\nChckBx_WPL|False\nDataGridView1|True\n";

